import { Routes } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { GuidePageComponent } from './pages/guide/guide-page.component';

export const routes: Routes = [
  { path: '', component: HomePageComponent },
  { path: 'guide', component: GuidePageComponent }
];
